export type NetworkErrorPayload = {
  status: number
  statusText: string
}

type Listener = (payload: NetworkErrorPayload) => void

/**
 * Pub/Sub notifier for XHR network errors.
 * Allows non-React code (e.g. utils.js) to publish network error events
 * that React components can subscribe to.
 *
 * Uses only plain JavaScript — no DOM APIs — for compatibility
 * with low-end devices (Tizen 2017, Comcast X1, etc.).
 */
class NetworkStatusNotifier {
  private listeners: Listener[] = []

  subscribe(listener: Listener): () => void {
    this.listeners.push(listener)
    return () => {
      this.listeners = this.listeners.filter((l) => l !== listener)
    }
  }

  notify(payload: NetworkErrorPayload): void {
    this.listeners.forEach((listener) => listener(payload))
  }
}

// Singleton instance shared across the app
const networkStatusNotifier = new NetworkStatusNotifier()

export default networkStatusNotifier
